/**
 * Get plural word form based on count (without the number)
 * @example getPluralWord(1, 'year') // "year"
 * @example getPluralWord(5, 'year') // "years"
 * @example getPluralWord(2, 'child', 'children') // "children"
 */
export const getPluralWord = (
  count: number,
  singular: string,
  plural?: string,
): string => (count === 1 ? singular : plural || `${singular}s`);

/**
 * Get plural text with count included
 * @example getPluralText(1, 'year') // "1 year"
 * @example getPluralText(5, 'year') // "5 years"
 * @example getPluralText(2, 'child', 'children') // "2 children"
 */
export const getPluralText = (
  count: number,
  singular: string,
  plural?: string,
): string => `${count} ${getPluralWord(count, singular, plural)}`;

/**
 * Get the ordinal suffix for a number
 * @param n - Number to get ordinal for
 * @returns Ordinal suffix (st, nd, rd, th)
 * @example
 * getOrdinal(1) // "st"
 * getOrdinal(2) // "nd"
 * getOrdinal(3) // "rd"
 * getOrdinal(4) // "th"
 * getOrdinal(21) // "st"
 */
export const getOrdinal = (n: number): string => {
  const suffixes = ['th', 'st', 'nd', 'rd'];
  const v = n % 100;

  return suffixes[(v - 20) % 10] || suffixes[v] || suffixes[0]!;
};
